import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDialogs } from "../hooks/use-dialogs";
import useExameModel from "../model/exame";
import useSchoolModel from "../model/school";
import { Exame } from "../types/exames";
import useExameStore from "../zustand/use-exame-store";
import useSchoolStore from "../zustand/use-school-store";

export const ViewModelExame = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const schoolIdParam = searchParams.get("school");

  const {
    exames,
    selectedExame,
    selectedSchoolId,
    setSelectedExame,
    setSelectedSchoolId,
  } = useExameStore();

  const {
    fetchSchools
  } = useSchoolModel();

  const { schools, } = useSchoolStore();

  const {
    fetchExames,
    fetchExamesBySchool,
    fetchSuggestions,
    createExame,
    updateExameById,
    validateExame,
    rejectExame,
    deleteExameById,
  } = useExameModel();

  const {
    close,
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  } = useDialogs();

  // Select exame for editing
  const selectExame = (exame: Exame) => {
    setSelectedExame(exame);
  };

  // Clear selection
  const clearSelection = () => {
    setSelectedExame(undefined as any);
  };

  // Navigate back to schools
  const goToSchools = () => {
    navigate("/schools");
  };

  useEffect(() => {
    fetchSchools();
    if (schoolIdParam) {
      fetchExamesBySchool(Number(schoolIdParam))
    } else {
      fetchExames();
    }
  }, [])

  const handleDeleteExame = (id: number) => {
    close();
    deleteExameById(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Exame removido com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao remover o exame!',
        })
      }
    })
  }

  const handleActionExame = (exame: Exame, action: 'add' | 'update') => {
    if (action === 'add') {
      createExame({
        title: exame.title,
        year: exame.year,
        url: exame.url,
        data: exame.data,
        visible: exame.visible,
        author: exame.author,
        schoolId: exame.school_id,
      }, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Exame criado com sucesso!'
          });
        },
        error: (error) => {
          console.log(error)
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao criar o exame!',
          })
        }
      });
    } else {
      updateExameById(exame, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Exame actualizado com sucesso!'
          });
        },
        error: () => {
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao actualizar o exame!',
          })
        }
      });
    }
  }

  const handleValidateExame = (id: number) => {
    close();
    validateExame(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Exame validado com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao validar o exame!',
        })
      }
    })
  }

  const handleRejectExame = (id: number) => {
    close();
    rejectExame(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Exame rejeitado com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao rejeitar o exame!',
        })
      }
    })
  }

  return {
    // State
    exames,
    selectedExame,
    selectedSchoolId,
    schools,
    schoolIdParam,
    // Actions
    fetchExames,
    fetchExamesBySchool,
    fetchSuggestions,
    handleActionExame,
    handleDeleteExame,
    handleValidateExame,
    handleRejectExame,
    selectExame,
    clearSelection,
    goToSchools,
    navigate,
    // Dialogs
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  };
};
